import { DataType } from '../query.types';
export function translateQueryGroup(queryGroup, fields) {
    if (queryGroup.rules != null) {
        var _loop_1 = function (rule) {
            if (rule.datas === undefined) {
                rule.datas = [undefined, undefined];
                if (rule.data) {
                    rule.datas[0] = rule.data;
                }
            }
            if (rule.datas) {
                rule['sdatas'] = rule.datas;
            }
            // if (rule.data) {
            //   rule['sdata'] = rule.data;
            // } else {
            //   rule.data = rule.datas[0]
            // }
            if (typeof rule.field === 'string') {
                field = fields.find(function (x) { return x.name === rule.field; });
                if (field === undefined || field === null) {
                    throw new Error("Can't found out a field by name '" + rule.field + "'.");
                }
                rule.field = field;
            }
            if (rule.field.type === DataType.date) {
                for (var i = 0; i <= rule.datas.length; i++) {
                    var d = rule.datas[i];
                    if (typeof d === 'string' && d && d !== null && d !== '') {
                        rule.datas[i] = new Date(d);
                    }
                }
            }
        };
        var field;
        for (var _i = 0, _a = queryGroup.rules; _i < _a.length; _i++) {
            var rule = _a[_i];
            _loop_1(rule);
        }
    }
    if (queryGroup.groups && queryGroup.groups !== null) {
        for (var _b = 0, _c = queryGroup.groups; _b < _c.length; _b++) {
            var group = _c[_b];
            translateQueryGroup(group, fields);
        }
    }
}
export function cloneQueryGroup(source) {
    var result = {
        op: source.op,
        groups: [],
        rules: []
    };
    if (source.rules && source.rules.length > 0) {
        for (var _i = 0, _a = source.rules; _i < _a.length; _i++) {
            var rule = _a[_i];
            result.rules.push({
                field: rule.field,
                op: rule.op,
                data: rule.data,
                datas: rule.datas ? rule.datas.map(function (x) { return x; }) : undefined
            });
        }
    }
    if (source.groups && source.groups.length > 0) {
        for (var _b = 0, _c = source.groups; _b < _c.length; _b++) {
            var child = _c[_b];
            result.groups.push(cloneQueryGroup(child));
        }
    }
    return result;
}
export function generateQuery(queryGroup, original) {
    if (queryGroup === undefined || queryGroup === null) {
        return undefined;
    }
    var result = {
        op: queryGroup.op,
        groups: [],
        rules: []
    };
    if (queryGroup.rules && queryGroup.rules.length > 0) {
        for (var _i = 0, _a = queryGroup.rules; _i < _a.length; _i++) {
            var rule = _a[_i];
            var field = rule.field;
            if (original === false && field && field.getRules) {
                var customRules = field.getRules(rule);
                if (customRules) {
                    (_b = result.rules).push.apply(_b, customRules);
                }
            }
            else {
                var rule2 = {
                    field: rule.field['name'],
                    op: rule.op,
                    data: undefined,
                    datas: undefined
                };
                if (rule.datas) {
                    var datas = [];
                    for (var _c = 0, _d = rule.datas; _c < _d.length; _c++) {
                        var d = _d[_c];
                        if (d instanceof Date) {
                            datas.push(d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate());
                        }
                        else {
                            datas.push(d);
                        }
                    }
                    if (rule2.op === 'bt') {
                        rule2.datas = datas;
                        while (rule2.datas.length < 2) {
                            rule2.datas.push(null);
                        }
                    }
                    else {
                        rule2.data = datas[0];
                    }
                    if (rule2.datas) {
                        for (var i = 0; i < rule2.datas.length; i++) {
                            if (rule2.datas[i] === undefined || rule2.datas[i] === null) {
                                rule2.datas[i] = '';
                            }
                        }
                    }
                }
                result.rules.push(rule2);
            }
        }
    }
    if (queryGroup.groups && queryGroup.groups.length > 0) {
        for (var _e = 0, _f = queryGroup.groups; _e < _f.length; _e++) {
            var child = _f[_e];
            result.groups.push(generateQuery(child, original));
        }
    }
    return result;
    var _b;
}
export function validateQuery(queryGroup) {
    var result = true;
    if (queryGroup === undefined || queryGroup === null) {
        return result;
    }
    if (queryGroup.rules && queryGroup.rules.length > 0) {
        for (var _i = 0, _a = queryGroup.rules; _i < _a.length; _i++) {
            var rule = _a[_i];
            var field = rule.field;
            if (field && field.validate) {
                result = field.validate(rule);
                if (!result) {
                    return result;
                }
            }
        }
    }
    if (queryGroup.groups && queryGroup.groups.length > 0) {
        for (var _b = 0, _c = queryGroup.groups; _b < _c.length; _b++) {
            var child = _c[_b];
            result = validateQuery(child);
            if (!result) {
                return result;
            }
        }
    }
    return result;
}
//# sourceMappingURL=query-helper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@zhongruigroup_ngx-query@1.0.1@@zhongruigroup/ngx-query/utils/query-helper.js
// module id = null
// module chunks = 